import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, Download, ShoppingBag, CheckCircle, Clock, Trash2 } from 'lucide-react';

export function AdminCouponsTab({ couponAnalytics, searchTerm, setSearchTerm, handleDeleteCoupon, exportCoupons }) {
  const filteredCoupons = couponAnalytics.filter(c =>
    !searchTerm || c.title?.toLowerCase().includes(searchTerm.toLowerCase()) || c.category?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <div className="relative flex-1 max-w-sm">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input placeholder="Buscar cupom..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
            className="pl-10" data-testid="coupon-search" />
        </div>
        <span className="text-sm text-slate-500">{filteredCoupons.length} cupons</span>
        <Button size="sm" variant="outline" className="border-slate-300 text-xs ml-auto" onClick={exportCoupons} data-testid="export-coupons-btn">
          <Download className="h-3.5 w-3.5 mr-1" /> CSV
        </Button>
      </div>

      <div className="space-y-2">
        {filteredCoupons.map(c => (
          <Card key={c.coupon_id} className="bg-white border border-slate-200" data-testid={`admin-coupon-${c.coupon_id}`}>
            <CardContent className="py-3">
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <p className="font-semibold text-slate-900 truncate">{c.title}</p>
                    <Badge className="bg-red-100 text-red-700 border-red-200 text-xs">{c.discount_percentage}% OFF</Badge>
                    {c.is_deleted && <Badge className="bg-red-500 text-white border-0 text-xs">Excluido</Badge>}
                    {!c.is_active && !c.is_deleted && <Badge className="bg-yellow-100 text-yellow-700 border-yellow-200 text-xs">Inativo</Badge>}
                    {c.merchant_plan && <Badge className="bg-slate-100 text-slate-500 border-slate-200 text-xs capitalize">{c.merchant_plan}</Badge>}
                  </div>
                  <p className="text-xs text-slate-500">
                    {c.merchant_name}{c.merchant_company ? ` (${c.merchant_company})` : ''} | {c.category} | {c.city}, {c.state} | {new Date(c.created_at).toLocaleDateString('pt-BR')}
                  </p>
                </div>
                <div className="flex items-center gap-2 flex-wrap shrink-0">
                  <Badge className="bg-blue-50 text-blue-700 border-blue-200 text-xs"><ShoppingBag className="h-3 w-3 mr-1" />{c.total_claims} enviados</Badge>
                  <Badge className="bg-emerald-50 text-emerald-700 border-emerald-200 text-xs"><CheckCircle className="h-3 w-3 mr-1" />{c.total_validations} validados</Badge>
                  <Badge className="bg-amber-50 text-amber-700 border-amber-200 text-xs"><Clock className="h-3 w-3 mr-1" />{c.pending_claims} pendentes</Badge>
                  {!c.is_deleted && (
                    <Button size="sm" variant="ghost" className="text-red-500 hover:text-red-700 h-7"
                      onClick={() => handleDeleteCoupon(c.coupon_id)} data-testid={`admin-delete-${c.coupon_id}`}>
                      <Trash2 className="h-3.5 w-3.5" />
                    </Button>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
